import { useContext } from "react";
import CardBlueHeart from "_+_Portal/_-_Autocheckin/components/genericos/CardBlueHeart/CardBlueHeart";
import LayoutPasos from "_+_Portal/_-_Autocheckin/components/genericos/LayoutPasos/LayoutPasos";
import ResumenLista from "_+_Portal/_-_Autocheckin/components/genericos/ResumenLista/ResumenLista";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";

import { setRuta } from "_+_Portal/_-_Autocheckin/context/action/ruta";

import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import {
  createListaResumen,
  createRuta,
  msjPaciente,
  proximoPaso,
} from "../PagesFun";
import {
  ResumenBotones,
  ResumenContainer,
  ResumenMensajes,
} from "./LocalStyle";

const Resumen = ({ turnoActual }) => {
  // -------------------------  context ----------------------------
  const {
    turnosSeleccionadosState,
    pasoDispatch,
    rutaDispatch,
    textosAutoCheckinState,
  } = useContext(AutocheckContext);

  // -------------------------  context ----------------------------

  // -------------------------  constantes ----------------------------

  const listTurnosSeleccionado =
    turnosSeleccionadosState?.turnosSeleccionados?.data ?? [];

  const turno = listTurnosSeleccionado?.[turnoActual];

  const medico = turno?.medico;
  const especialidad = turno?.especialidad;

  const irPuntoControl = () => {
    setPaso("PuntoControl")(pasoDispatch);
  };
  const ResubirOrden = () => {
    setPaso("SubirOrden")(pasoDispatch);
  };
  const listaResumen = createListaResumen(
    {
      ...turno?.resumen,
      flgSoloConsulta: turno?.flgSoloConsulta,
      flgSoloPractica: turno?.flgSoloPractica,
      requiereAutorizacion: turno?.requiereAutorizacion,
    },
    irPuntoControl,
    ResubirOrden,
  );

  const mensajeStr =
    "El turno cuenta con lo necesario para hacer la validación con tu cobertura y terminar la recepción";
  let msj = msjPaciente(listaResumen);
  msj =
    msj === 2
      ? textosAutoCheckinState.textosAutoCheckin?.data?.estadoTurnoBien?.nombre
      : msj === 1
        ? textosAutoCheckinState.textosAutoCheckin?.data?.estadoTurnoRegular
            ?.nombre
        : textosAutoCheckinState.textosAutoCheckin?.data?.estadoTurnoMal?.nombre;

  // -------------------------  constantes ----------------------------

  // -------------------------  useEffects  ----------------------------

  //  -------------------------  useEffects  ----------------------------

  // -------------------------  funciones  ----------------------------
  const handleContinuar = () => {
    const ruta = createRuta(listaResumen);
    setRuta(proximoPaso(ruta, setPaso, pasoDispatch))(rutaDispatch);
  };
  // -------------------------  funciones ----------------------------

  return (
    <LayoutPasos
      volverTo={"/autocheckin"}
      handleClick={() => {
        setPaso("NumeroAfiliado")(pasoDispatch);
      }}
      type={"no-circle"}
      title={"AUTO CHECK IN"}
    >
      <CardBlueHeart
        medico={medico ? medico : especialidad}
        turnoTitle={especialidad}
        pasoActual={turnoActual + 1}
        pasoTotal={listTurnosSeleccionado?.length ?? 0}
      />
      <ResumenContainer
        initial={{ opacity: 0, y: +100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.4 }}
      >
        <ResumenMensajes>
          <span
            className="resumenmensajes-titulo rb24b"
            dangerouslySetInnerHTML={{ __html: msj }}
          />
          <span className="resumenmensajes-mensaje rb18m">{mensajeStr}</span>
        </ResumenMensajes>
        <ResumenLista lista={listaResumen} />
        <ResumenBotones>
          <button className="btn bgc-primary c-white" onClick={handleContinuar}>
            <span className="rb18m">Continuar</span>
          </button>
        </ResumenBotones>
      </ResumenContainer>
    </LayoutPasos>
  );
};

export default Resumen;
